"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  line-height: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _default = function _default(_ref) {
  var _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? 'Objektiv Mk2' : _ref$fontFamily,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? 400 : _ref$fontWeight,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 16 : _ref$fontSize,
      _ref$letterSpacing = _ref.letterSpacing,
      letterSpacing = _ref$letterSpacing === void 0 ? 0 : _ref$letterSpacing,
      _ref$lineHeightPx = _ref.lineHeightPx,
      lineHeight = _ref$lineHeightPx === void 0 ? 24 : _ref$lineHeightPx;
  return (0, _uiKit.css)(_templateObject(), fontFamily === 'Objektiv Mk2' ? _uiKit.FontFamilyValue.primary : _uiKit.FontFamilyValue.tertiary, fontWeight, fontSize, letterSpacing, lineHeight);
};

exports.default = _default;